"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTreeView = exports.TreeViewProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var TreeViewContext = react_1.default.createContext(undefined);
function TreeViewProvider(_a) {
    var expandedIcon = _a.expandedIcon, collapsedIcon = _a.collapsedIcon, itemsGap = _a.itemsGap, expanded = _a.expanded, children = _a.children, toggleButtonOptions = _a.toggleButtonOptions, areAllNodesLeaf = _a.areAllNodesLeaf;
    return (react_1.default.createElement(TreeViewContext.Provider, { value: { expandedIcon: expandedIcon, collapsedIcon: collapsedIcon, itemsGap: itemsGap, expanded: expanded, toggleButtonOptions: toggleButtonOptions, areAllNodesLeaf: areAllNodesLeaf } }, children));
}
exports.TreeViewProvider = TreeViewProvider;
function useTreeView() {
    var context = react_1.default.useContext(TreeViewContext);
    if (context === undefined) {
        throw new Error('useTreeView must be used within a TreeViewProvider');
    }
    return context;
}
exports.useTreeView = useTreeView;
//# sourceMappingURL=tree-view-context.js.map